module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signature-box"
  }, [(_vm.type === 'draw') ? [_c('canvas', {
    class: ("signature-box__canvas " + (_vm.isDisabled ? 'is-disabled' : ''))
  }), _vm._v(" "), _c('div', {
    staticClass: "signature-box__canvas__buttons"
  }, [(_vm.drawnSignature) ? _c('a', {
    staticClass: "signature-box__canvas__clear",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.clearCanvas
    }
  }, [_c('icon', {
    attrs: {
      "name": "trash",
      "height": "16",
      "width": "16"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('signatureBox.clear')))])], 1) : _vm._e()]), _vm._v(" "), (_vm.isDisabled) ? _c('message', {
    attrs: {
      "type": "warning",
      "iconName": "warning"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('signatureBox.clearFirst')) + "\n    ")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.type === 'type') ? [_c('div', {
    staticClass: "signature-box__type"
  }, [_c('input', {
    ref: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.typedSignature
    },
    on: {
      "input": _vm.typeSignature
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "signature-box__type__input"
  }, [_vm._v(_vm._s(_vm.typedSignature ? _vm.typedSignature : _vm.$t('signatureBox.yourSignature')))])])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12862ad2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SignatureBox.vue
// module id = 1042
// module chunks = 1